import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=05d769b4"
import script from "./Account.vue?vue&type=script&lang=ts&setup=true"
export * from "./Account.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports